import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReconstruirPdfComprobanteResponse } from '@models/snapshot-comprobante/reconstruirPdfComprobanteResponse.model';
import { SnapshotComprobanteInfoDto } from '@models/snapshot-comprobante/snapshotComprobanteInfoDto.model';

/**
 * Reconstrucción de comprobantes a partir del HTML guardado al emitirlos.
 *
 * Es una vía SECUNDARIA: la descarga normal sigue usando el archivo original
 * (ArchivosTemporal). Esto resuelve el caso de que ese archivo ya no exista,
 * porque se borran por antigüedad según DuracionMesesArchivosTemporales.
 */
@Injectable({
  providedIn: 'root'
})
export class SnapshotComprobanteService {

  constructor(private http: HttpClient) { }

  /** Devuelve el PDF en base64, regenerado desde el respaldo */
  reconstruirPdf(idComprobante: number): Observable<ReconstruirPdfComprobanteResponse> {
    return this.http.get<ReconstruirPdfComprobanteResponse>(
      "/api/SnapshotComprobante/ReconstruirPdf?idComprobante=" + idComprobante);
  }

  /** Indica si el comprobante tiene respaldo y desde cuándo */
  getInfo(idComprobante: number): Observable<SnapshotComprobanteInfoDto> {
    return this.http.get<SnapshotComprobanteInfoDto>(
      "/api/SnapshotComprobante/GetInfo?idComprobante=" + idComprobante);
  }
}
